import React from 'react';
import { useSignUpActions } from './useSignUpActions';

interface SignUpContextData extends ReturnType<typeof useSignUpActions> {
    isInvitationFlow: boolean;
}

const SignUpContext = React.createContext<SignUpContextData | undefined>(undefined);

export const useSignUpContext = () => {
    const context = React.useContext(SignUpContext);

    if (!context) {
        throw new Error('useSignUpContext must be used inside SignUpContext');
    }

    return context;
};

export const SignUpContextProvider: React.FC = ({ children }) => {
    const { organizationId, invitationData, signUp, acceptInvitation, createOrganization, checkInvitation } =
        useSignUpActions();

    return (
        <SignUpContext.Provider
            value={{
                organizationId,
                isInvitationFlow: !!invitationData,
                invitationData,
                signUp,
                createOrganization,
                checkInvitation,
                acceptInvitation,
            }}
        >
            {children}
        </SignUpContext.Provider>
    );
};
